import { Drama, Factory, HardHat, Landmark, Star, Trophy } from 'lucide-react';
import { motion } from 'motion/react';

import { useI18n } from '../../i18n';

export default function SectorsWeServeSection() {
  const { t } = useI18n();

  const sectors = [
    {
      icon: HardHat,
      title: t.sectorsWeServe.sectors.construction,
    },
    {
      icon: Trophy,
      title: t.sectorsWeServe.sectors.sports,
    },
    {
      icon: Drama,
      title: t.sectorsWeServe.sectors.entertainment,
    },
    {
      icon: Landmark,
      title: t.sectorsWeServe.sectors.government,
    },
    {
      icon: Factory,
      title: t.sectorsWeServe.sectors.industrial,
    },
  ];

  return (
    <motion.section
      id="sectors"
      className="relative overflow-hidden bg-white px-4 py-12 sm:px-6 sm:py-16 md:px-8 md:py-20 lg:px-32"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      <div className="relative z-10">
        <motion.div
          className="mb-10 text-center"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <motion.div
            className="flex flex-col items-center justify-center gap-6"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl md:text-4xl">
              {t.sectorsWeServe.title}
            </h2>
            <motion.div
              className="mx-auto h-1 w-full max-w-4xl bg-emerald-500"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              viewport={{ once: true }}
            />
          </motion.div>
        </motion.div>

        <div className="mx-auto grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5 md:gap-6">
          {sectors.map((sector, index) => {
            const Icon = sector.icon;

            return (
              <motion.div
                key={index}
                className="flex flex-col items-center gap-4 rounded-xl bg-white p-6 shadow-lg"
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{
                  delay: 0.2 + index * 0.1,
                  duration: 0.6,
                  ease: 'easeOut',
                }}
                viewport={{ once: true }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                  transition: { duration: 0.2 },
                }}
              >
                <Icon className="h-12 w-12 text-emerald-500" />
                <span className="text-center text-base font-medium text-gray-900 sm:text-lg">
                  {sector.title}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.section>
  );
}
